import './styles.scss';
import '@xyflow/react/dist/style.css';

import { useEffect, useRef } from 'react';
import { ReactFlow, ReactFlowProvider, useReactFlow } from '@xyflow/react';

import EntryNode from './components/EntryNode';
import ReceiverNode from './components/ReceiverNode';
import InvitationNode from './components/InvitationNode';
import AddReceiverNode from './components/AddReceiverNode';
import SplitFlowEdge from './components/SplitFlowEdge';

// Must be stable (outside component) — React Flow re-creates internal state on nodeTypes changes
const nodeTypes = {
    entryNode: EntryNode,
    receiverNode: ReceiverNode,
    invitationNode: InvitationNode,
    addReceiverNode: AddReceiverNode,
};

const edgeTypes = {
    splitFlowEdge: SplitFlowEdge,
};

const FIT_OPTIONS = { padding: 0.08, maxZoom: 1 };

function RefitOnChange({ count }) {
    const { fitView } = useReactFlow();
    const prevCount = useRef(count);

    useEffect(() => {
        if (prevCount.current === count) return;
        prevCount.current = count;
        // Wait a frame so the new node is measured before fitting
        requestAnimationFrame(() => fitView({ ...FIT_OPTIONS, duration: 350 }));
    }, [count, fitView]);

    return null;
}

export default function SplitFlowView({ nodes, edges, height }) {
    return (
        <div className="split-flow" style={{ height }}>
            <ReactFlowProvider>
                <ReactFlow
                    nodes={nodes}
                    edges={edges}
                    nodeTypes={nodeTypes}
                    edgeTypes={edgeTypes}
                    fitView
                    fitViewOptions={FIT_OPTIONS}
                    nodesDraggable={false}
                    nodesConnectable={false}
                    elementsSelectable={false}
                    panOnDrag={false}
                    zoomOnScroll={false}
                    zoomOnPinch={false}
                    zoomOnDoubleClick={false}
                    preventScrolling={false}
                    deleteKeyCode={null}
                    proOptions={{ hideAttribution: true }}
                >
                    <RefitOnChange count={nodes.length} />
                </ReactFlow>
            </ReactFlowProvider>
        </div>
    );
}
